import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";

export const ProfitLoss = () => {
    document.title = "Mənfəət və zərər";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Hesabatlar", value: "/reports" },
        { name: "Mənfəət və zərər", value: "/reports/profitloss" },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Mənfəət və zərər</h2>
                    <p>
                        Sahibkarın müəyyən dövr ərzində etdiyi <b>satış dövriyyəsi</b>, <b>dövriyyənin mayası</b>, <b>ümumi mənfəəti</b>, həmin müddət ərzində
                        etdiyi <b>xərcləri</b> nəzərə alaraq təmiz mənfəətin göstəricisidir
                        <br />
                        Nümunədə Hesabatlar ⮞ Mənfəət səhifəsinə baxmaq üçün ardıcıllıq göstərilib
                    </p>
                    <img src="/images/reports/profitloss.gif" alt="Mənfəət və zərər" />
                </article>
            </div>
        </div>
    );
};
